export default "__VITE_ASSET__6vKlVPVK__"